import React, { useContext } from 'react';
import context from '../context';
import styled from 'styled-components';
import Link from './link';
import { Button } from '../styled-components';
import nasaImg from '../images/nasa.jpg'; // ✅ ruta corregida

const BgSection = styled.section`
  position: relative;
  background-image: url(${nasaImg});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  margin-top: -6rem;

  background-color: #000;
  padding: 4rem 1rem;

  &::before {
    content: "";
    position: absolute;
    inset: 0;
    background: rgba(0, 0, 0, 0); /* oscurece un poco el fondo */
    z-index: 0;
  }

  > * {
    position: relative;
    z-index: 1; /* contenido encima */
  }
`;

const ContactCont = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  color: #fff; /* texto blanco sobre fondo oscuro */
`;

const ContactTitle = styled.h3`
  font-size: 2rem;
  margin-bottom: 1rem;
`;

const ContactSubTitle = styled.p`
  font-size: 1.2rem;
  margin: 1.5rem 0;
  color: black;
  font-weight: bold
`;

export default () => {
  const state = useContext(context);
  return (
    <BgSection>
      <ContactCont>
        <ContactTitle>
          ¿Tienes alguna duda?
        </ContactTitle>
        <ContactSubTitle>
          Llámanos o escríbenos.
        </ContactSubTitle>
        <Link to="/contact">
          <Button primary>
            Contacto
          </Button>
        </Link>
      </ContactCont>
    </BgSection>
  );
};